module.exports = __webpack_public_path__ + "media/whale-5-30.5a1dae95.mp4";